import React, { useState } from 'react';
import { FormattedMessage, useIntl } from '../../util/reactIntl';
import { FiClock } from 'react-icons/fi';
import { houseRulesOptions } from '../../util/selectableIcons';
import css from './ListingPage.module.css';
import { PrimaryButton } from '../../components';

const MAX_ITEMS = 5;

const SectionHouseRules = props => {
  const intl = useIntl();
  const { publicData } = props;
  const [showMore, setShowMore] = useState(false);

  const houseRules = publicData?.houseRules || {};
  const checkInTime = houseRules.checkInTime;
  const checkOutTime = houseRules.checkOutTime;
  const additionalRules = houseRules.additionalRules;
  const rules = houseRules.rules || [];
  const hasRules = rules.length > 0;

  const visibleRules = showMore ? rules : rules.slice(0, MAX_ITEMS);

  const getIconComponent = iconId => {
    const iconConfig = houseRulesOptions.find(icon => icon.id === iconId);
    return iconConfig?.icon || null;
  };

  const onToggleShowMore = () => {
    setShowMore(prev => !prev);
  };

  const shouldShowButton = rules.length > MAX_ITEMS;

  return (
    <section className={css.sectionHouseRulesContainer}>
      <h2 className={`${css.heading} ${css.customAdviceheading}`}>
        <FormattedMessage id="SectionHouseRules.heading" />
      </h2>
      {hasRules || additionalRules ? (
        <div className={css.houseRuleDescription}>
          <FormattedMessage id="SectionHouseRules.description" />
        </div>
      ) : (
        <div className={css.houseRuleDescription}>
          <FormattedMessage id="SectionHouseRules.noHouseRules" />
        </div>
      )}

      {hasRules && (
        <ul className={css.houseRulesContainer}>
          {visibleRules.map((rule, index) => {
            const IconComponent = getIconComponent(rule.iconId);

            return (
              <li key={`${rule.iconId}-${index}`} className={css.houseRuleItem}>
                {IconComponent && <IconComponent />}
                <p>{rule.label}</p>
              </li>
            );
          })}
        </ul>
      )}

      {((additionalRules && showMore) || (!hasRules && additionalRules)) && (
        <div className={css.additionalRulesContainer}>
          <div className={css.additionalRulesTitle}>
            <FormattedMessage id="SectionHouseRules.additionalRulesTitle" />
          </div>
          <p className={css.additionalRulesText}>{additionalRules}</p>
        </div>
      )}

      {shouldShowButton ? (
        <PrimaryButton className={css.sectionHouseRulesButton} onClick={onToggleShowMore}>
          {showMore ? (
            <FormattedMessage id="SectionHouseRules.showLess" />
          ) : (
            <FormattedMessage id="SectionHouseRules.showMore" />
          )}
        </PrimaryButton>
      ) : null}
    </section>
  );
};

export default SectionHouseRules;
